import { render } from "./ProjectSourcesSplash.vue?vue&type=template&id=2a0527bc"
import script from "./ProjectSourcesSplash.vue?vue&type=script&lang=js"
export * from "./ProjectSourcesSplash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__